<div id="categoryBase" class="routBase">
    <header>
        <div class="container">
            <a (click)="_location.back()" title="Go Back"><i class="fas fa-arrow-left"></i></a>
            <h5 *ngIf="pageSearchType">{{ 'global.search' | translate }} <span>{{ pageTitle }}</span><b> ({{ catContents?.length }} {{ 'global.results' |translate }})</b></h5>
            <h5 *ngIf="!pageSearchType">{{ pageTitle }}</h5>
        </div>
    </header>
    <div class="container px-0 px-md-3">
        <div class="gameGrid">

            <main class="px-3 px-md-0">

                <div *ngFor="let game of catContents" routerLink="/game/{{game.catId}}/{{game.id}}" class="gameThumb p-2 px-xl-3">
                    <img src="{{ global.propConfs$?.proxyCachefly ? '/neo-cachefly' : 'https://lxneo.cachefly.net/m3/cache' }}/{{ game.id }}_55.jpg" [alt]="game.name">
                    <p>{{ game.name }}</p>
                    <div class="rankStars">
                        <span *ngFor="let star of [].constructor(game.rank)"><i class="fas fa-star"></i></span>
                    </div>
                </div>

            </main>
            
        </div>

        <div *ngIf="!catContents || loadingContents" class="contentLoader my-5">
            <span></span>
        </div>

        <a *ngIf="!pageSearchType && showSeeMore && catContents && !loadingContents" (click)="getMoreContent()" class="seeMoreBtn mt-2 mb-3">{{ 'global.seeMore' | translate }}</a>
        <h5 *ngIf="catContents && catContents.length <= 0" class="text-center my-5">{{ 'global.noContent' | translate }}</h5>

    </div>
</div>
